import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { getFilters } from '../redux/reducers/filters'

export function useGetPickedFilterSetsByKeys(keys) {
  const filters = useSelector(getFilters)

  return useMemo(() => {
    return _.reduce(keys, (filtersMap, key) => ({
      ...filtersMap,
      [`${key}`]: filters[key]
    }), {})
  }, [filters, keys])
}
